module.exports = __webpack_public_path__ + "img/bank-card-2-line.c37e1f8a.svg";